/** Represents an app record in the system */
export interface AppRecord {
  label: string
  url?: string
  package_name?: string

  /** Base64 string that should be fetched from the device */
  icon?: string

  /** List of categories the app belongs to */
  categories?: string[]

  /** Flag to signify that the app is installed */
  is_installed?: boolean
}

export interface AppCategory {
  /** Category Label */
  label: string

  /** Category Value */
  value: string
}

export enum AppScreenModes {
  MY_APPS = "my_apps",
  APP_LIBRARY = "app_library",
}
